import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0a0b29a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5 ws_common_form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import {
  PACKAGE_CHARGE_MODE_ENUM,
  CODE_ENUM,
  PACKAGE_TYPE_ENUM,
} from '@/common'
import { packageInfoAdd, getPackageInfo, packageInfoUpdate } from '@/api'
import Steps from '@/components/steps'
import PackageForm2 from './package-form-step2.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'package-form-step1',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      moResourceIds.value = []
      queryDetail()
    }
  }
)

const isPerson = computed(() => {
  return props.data?.packageUserTypeCode !== PACKAGE_TYPE_ENUM.PACKAGE_COMPANY
})

const formData = ref({
  packageName: '',
  chargeMode: '',
  chargModePeriod: undefined,
  shortMsgTotal: undefined,
  price: undefined,
  vipPrice: undefined,
  packageDescription: '',
})

const options = [
  {
    value: PACKAGE_CHARGE_MODE_ENUM.PACKMONTH,
    label: '包月',
  },
  {
    value: PACKAGE_CHARGE_MODE_ENUM.PACKYEAR,
    label: '包年',
  },
]

const STEP_ENUM = {
  BASEINFO: 0,
  RESOURCE: 1,
}
const active = ref(STEP_ENUM.BASEINFO)

const steps = [
  {
    title: '基础信息',
    value: 0,
  },
  {
    title: '应用资源',
    value: 1,
  },
]

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
  active.value = STEP_ENUM.BASEINFO
  detailData.value = {}
  formData.value = {
    packageName: '',
    chargeMode: '',
    chargModePeriod: undefined,
    shortMsgTotal: undefined,
    price: undefined,
    vipPrice: undefined,
    packageDescription: '',
  }
  moResourceIds.value = []
}

const rules: any = {
  packageName: [{ required: true, message: '请输入' }],
  chargeMode: [{ required: true, message: '请选择' }],
  price: [{ required: true, message: '请输入' }],
  vipPrice: [{ required: true, message: '请输入' }],
  chargeType: [{ required: true, message: '请选择' }],
  shortMsgTotal: [{ required: true, message: '请输入' }],
  chargModePeriod: [{ required: true, message: '请输入' }],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

// 用来暂存已选的选项
const moResourceIds = ref([])

const detailData: any = ref({})
const detailLoading = ref(false)
const queryDetail = async () => {
  if (!props.data.id) {
    return
  }
  detailLoading.value = true
  const res: any = await getPackageInfo({
    id: props.data.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    detailLoading.value = false
    detailData.value = res.data || {}
    const {
      chargeMode,
      packageDescription,
      packageName,
      price,
      applicationDataList,
      chargModePeriod,
      shortMsgTotal,
      vipPrice,
    } = res.data
    formData.value = {
      packageName,
      chargeMode,
      price,
      packageDescription,
      chargModePeriod,
      shortMsgTotal,
      vipPrice,
    }
    // 将资源id提取出来
    moResourceIds.value = (applicationDataList || []).reduce(
      (mo: any, el: any) => {
        ;(el.directories || []).map((directory: any) => {
          const { menues } = directory
          const list = menues.map((item: any) => {
            const resourceId = (item.children || []).map((m: any) => {
              return m.id
            }, [])
            return resourceId
          })
          mo = mo.concat(list.flat(Infinity))
        })
        return mo
      },
      []
    )
  }
}

const nextStep = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      packageConf.value = {
        visible: true,
        data: {
          moResourceIds: moResourceIds.value,
        },
      }
    }
  })
}

const onChecked = (resourceIds: any) => {
  moResourceIds.value = resourceIds
}

const handSubmit = async (resourceIds: any) => {
  return new Promise(async (reslove: any, reject: any) => {
    const {
      chargeMode,
      packageName,
      packageDescription,
      price,
      chargModePeriod,
      shortMsgTotal,
      vipPrice,
    } = formData.value

    loading.value = true
    const fn = props.data.id ? packageInfoUpdate : packageInfoAdd
    const res: any = await fn({
      chargeMode,
      packageName,
      packageDescription,
      price,
      chargModePeriod,
      shortMsgTotal,
      resourceIds,
      vipPrice,
      id: props.data.id,
      packageUserTypeCode:
        props.data?.packageUserTypeCode || PACKAGE_TYPE_ENUM.PACKAGE_PRIVATE,
    }).finally(() => {
      loading.value = false
    })
    if (res?.code === CODE_ENUM.SUCCESS) {
      ElMessage({
        message: props.data.id ? '修改套餐成功' : '新建套餐成功',
        type: 'success',
      })
      cancel()
      $emit('success')
      reslove(true)
    } else {
      reslove(false)
    }
  })
}

const preStep = () => {
  active.value = STEP_ENUM.BASEINFO
}

const packageConf: any = ref({
  visible: false,
  data: {},
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: props.data.id ? '编辑套餐' : '添加套餐',
    size: "480px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: nextStep
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 下一步 ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Steps), {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        steps: steps,
        class: "ws_mb25"
      }, null, 8, ["modelValue"]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "right",
          "label-width": "80"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "packageName",
              label: "套餐名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.packageName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.packageName) = $event)),
                  maxlength: "20",
                  placeholder: "请输入套餐名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (detailData.value.chargeMode !== _unref(PACKAGE_CHARGE_MODE_ENUM).FREE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_el_form_item, {
                    prop: "chargeMode",
                    label: "计费模式"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: formData.value.chargeMode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.chargeMode) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                            return _createVNode(_component_el_radio, {
                              key: item.value,
                              label: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "chargModePeriod",
                    label: "生效周期"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        class: "ws_common_number ws_select",
                        "controls-position": "right",
                        modelValue: formData.value.chargModePeriod,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.chargModePeriod) = $event)),
                        maxlength: "20",
                        placeholder: "请输入",
                        controls: true,
                        min: 1,
                        precision: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (isPerson.value)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "shortMsgTotal",
                        label: "回传报文条数"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "ws_common_number ws_select",
                            modelValue: formData.value.shortMsgTotal,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.shortMsgTotal) = $event)),
                            maxlength: "20",
                            placeholder: "请输入1-1000",
                            controls: false,
                            min: 1,
                            max: 1000,
                            precision: 0
                          }, {
                            suffix: _withCtx(() => [
                              _createTextVNode("条/天")
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    prop: "price",
                    label: "价格"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        class: "ws_common_number ws_select",
                        modelValue: formData.value.price,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.price) = $event)),
                        maxlength: "20",
                        placeholder: "请输入",
                        controls: false,
                        min: 0.01,
                        precision: 2
                      }, {
                        suffix: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (isPerson.value)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        prop: "vipPrice",
                        label: "会员价格"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "ws_common_number ws_select",
                            modelValue: formData.value.vipPrice,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.vipPrice) = $event)),
                            maxlength: "20",
                            placeholder: "请输入",
                            controls: false,
                            min: 0.01,
                            max: 9999,
                            precision: 2
                          }, {
                            suffix: _withCtx(() => [
                              _createTextVNode("元")
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "packageDescription",
              label: "套餐说明"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.packageDescription,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.packageDescription) = $event)),
                  maxlength: "200",
                  placeholder: "请输入套餐说明",
                  rows: 4,
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]), [
          [_vShow, STEP_ENUM.BASEINFO === active.value]
        ])
      ])), [
        [_directive_loading, detailLoading.value]
      ]),
      _createVNode(PackageForm2, {
        steps: steps,
        visible: packageConf.value.visible,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((packageConf.value.visible) = $event)),
        data: packageConf.value.data,
        onOnChecked: onChecked,
        handSubmit: handSubmit
      }, null, 8, ["visible", "data"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})